// extracted by mini-css-extract-plugin
export default {"wrapper":"footer_wrapper__0UgDM","bybtn":"footer_bybtn__zIfT3"};